import Button from './Button'

export default {
	install: vue => {
		vue.component('e-button', Button)
	},
}
